/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * @Deprecated, use absdk/preliminary/commons/app/router/RouterUtils instead.
 */
export class RouteUtils {
  constructor() {
    // static class only
  }

  // Initially used 'route: IRoute' instead of current 'routeParams: RouteParams' in all get*ParamAs* methods below,
  // as wanted to be access to routeTemplate for better error messages.  Simplified for absdk simple routing so that
  // absdk dev only needs to deal with finer-grained 'routeParams'   As a result, still try to get the routeTemplate
  // for error messages if it is still available on the routeParams object (as IRoute extends RouteParams)
  static getRouteTemplateFragment(routeParams, ifFoundPrefix, notFoundValue) {
    const routeTemplate = routeParams.routeTemplate;
    return routeTemplate ? ifFoundPrefix + routeTemplate : notFoundValue;
  }
  static throwParamNotFound(routeParams, paramName) {
    throw new Error(`Required parameter ${paramName} not found ` + this.getRouteTemplateFragment(routeParams, "for route: ", " in route"));
  }
  static getReqParamAsString(routeParams, paramName) {
    const paramVal = RouteUtils.getParamAsString(routeParams, "routeParams", paramName);
    if (paramVal == null) {
      this.throwParamNotFound(routeParams, paramName);
    }
    return paramVal;
  }
  static getOptParamAsString(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsString(routeParams, "routeParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getExtraParamAsString(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsString(routeParams, "routeExtraParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getParamAsString(routeParams, paramGroup, paramName) {
    const propMap = routeParams[paramGroup] ?? {};
    const paramVal = propMap[paramName];
    if (paramVal == null) {
      return undefined; // collapse null and undefined
    }
    if (typeof paramVal === "string") {
      return paramVal;
    }
    throw new Error(`Parameter ${paramName} ` + this.getRouteTemplateFragment(routeParams, "in route ", "") + `should be of type string but was: ${typeof paramVal}`);
  }
  static getReqParamAsNumber(routeParams, paramName) {
    const paramVal = RouteUtils.getParamAsNumber(routeParams, "routeParams", paramName);
    if (paramVal == null) {
      this.throwParamNotFound(routeParams, paramName);
    }
    return paramVal;
  }
  static getOptParamAsNumber(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsNumber(routeParams, "routeParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getExtraParamAsNumber(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsNumber(routeParams, "routeExtraParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getParamAsNumber(routeParams, paramGroup, paramName) {
    const propMap = routeParams[paramGroup] ?? {};
    const paramVal = propMap[paramName];
    if (paramVal == null || paramVal === "") {
      return undefined; // collapse null and undefined and empty string to 'undefined'
    }
    const paramType = typeof paramVal;
    if (paramType === "string") {
      try {
        const parsed = parseInt(paramVal, 10);
        if (!isNaN(parsed)) {
          return parsed;
        }
        throw new Error("NaN");
      } catch (err) {
        throw new Error(`Parameter ${paramName} ` + this.getRouteTemplateFragment(routeParams, "in route ", "") + `had string value '${paramVal}' that could not be parsed to a number`);
      }
    }
    if (paramType === "number") {
      return paramVal;
    }
    throw new Error(`Parameter ${paramName} ` + this.getRouteTemplateFragment(routeParams, "in route ", "") + `could not be coerced to number as it was type: ${paramType}`);
  }
  static getReqParamAsBoolean(routeParams, paramName) {
    const paramVal = RouteUtils.getParamAsBoolean(routeParams, "routeParams", paramName);
    if (paramVal == null) {
      this.throwParamNotFound(routeParams, paramName);
    }
    return paramVal;
  }
  static getOptParamAsBoolean(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsBoolean(routeParams, "routeParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getExtraParamAsBoolean(routeParams, paramName, defaultVal) {
    const val = RouteUtils.getParamAsBoolean(routeParams, "routeExtraParams", paramName);
    return val !== undefined ? val : defaultVal;
  }
  static getParamAsBoolean(routeParams, paramGroup, paramName) {
    const propMap = routeParams[paramGroup] ?? {};
    const paramVal = propMap[paramName];
    if (paramVal == null) {
      return undefined; // collapse null and undefined to 'undefined'
    }
    const paramType = typeof paramVal;
    // Be very picky: only support 'true' and 'false' as strings, and anything else is an error.
    // Do NOT support Yes/No/0/1/...   If want this behavior, add new 'getParamAsBooleanish' method...
    if (paramType === "string") {
      if (paramVal === "true") {
        return true;
      }
      if (paramVal === "false") {
        return false;
      }
      throw new Error(`Parameter ${paramName} ` + this.getRouteTemplateFragment(routeParams, "in route ", "") + `had string value '${paramVal}' that could not be parsed to a boolean`);
    }
    if (paramType === "boolean") {
      return paramVal;
    }
    throw new Error(`Parameter ${paramName} ` + this.getRouteTemplateFragment(routeParams, "in route ", "") + `could not be coerced to boolean as it was type: ${paramType}`);
  }
}
//# sourceMappingURL=RouteUtils.js.map
